export const arcDetails = {
    setUp: { 
      name: "Set Up", 
      subtitle: "Thesis",
      description: "Establishes the protagonist's world and introduces their emotional flaw or misguided belief. Introduces the main conflict (both external and internal). Ends when the protagonist actively commits to a course of action.",
      color: "#4A90E2",
      lightColor: "#E3F2FD"
    },
    buildUp: { 
      name: "Build Up", 
      subtitle: "Antithesis",
      description: "The protagonist pursues an external goal in a new or unfamiliar world. Internal doubts begin to form as stakes increase. Ends with a pivotal realization or disruption.",
      color: "#7ED321",
      lightColor: "#E8F5E8"
    },
    breakUp: { 
      name: "Break Up", 
      subtitle: "Rethesis",
      description: "The protagonist begins to unravel—externally through setbacks and internally through disillusionment or sacrifice. The lowest point occurs here, where transformation becomes necessary or inevitable.",
      color: "#e42e54",
      lightColor: "#fce8ed"
    },
    wrapUp: { 
      name: "Wrap Up", 
      subtitle: "Synthesis",
      description: "The protagonist rises from despair with renewed clarity or strength. Final trials test their transformation. Culminates in a resolution where the protagonist emerges changed or accepts their tragic fate.",
      color: "#a85cd9",
      lightColor: "#f0e7f7"
    }
  };